<template>
  <div>
    <div />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { SYSTEM_SETTINGS, CALENDAR, LOCALIZATION } from '@/constants/store.js'

  export default {
    watch: {
      token: {
        immediate: true,
        handler (newVal) {
          if (newVal) {
            this.getCurrentUserInfo()
          }
        }
      }
    },
    created () {
      const vm = this
      Promise.all([
        vm.getDayOffDatesAction(),
        vm.getLocalizationStatus(),
        vm.getTestStatusAction()])
        .then(vm.settingsIsLoadedAction)
        .catch(vm.throwIfNotServerError)
    },
    methods: {
      ...mapActions(SYSTEM_SETTINGS.NAMESPACE, {
        settingsIsLoadedAction: SYSTEM_SETTINGS.ACTIONS.SETTINGS_IS_LOADED,
        getTestStatusAction: SYSTEM_SETTINGS.ACTIONS.GET_TEST_STATUS,
        getLocalizationStatusAction: SYSTEM_SETTINGS.ACTIONS.GET_LOCALIZATION_STATUS
      }),
      ...mapActions(CALENDAR.NAMESPACE, {
        getDayOffDatesAction: CALENDAR.ACTIONS.GET_DAY_OFF_DATES
      }),
      ...mapActions(LOCALIZATION.NAMESPACE, {
        setLocaleAction: LOCALIZATION.ACTIONS.SET_LOCALE
      }),
      getLocalizationStatus: async function () {
        try {
          await this.getLocalizationStatusAction()
          if (!this.localizationEnabled && this.systemLocale !== 'ru') {
            await this.setLocaleAction('ru')
          }
        } catch (error) {
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
